<script lang='ts'>
  import { Icon, Input, InputGroup, Popover } from "sveltestrap"
  import type { Contain } from "../Model/Contain"
  import type { Param } from "../Model/Param"
  import { containsService, paramsService } from "../services"
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let searchFilterComponent = {
      id : null,
      selectMotive : null,
      date : null
  };

  let contains: Contain[];
  let containsShow: Contain[] = [];
  let params: Param[];
  
  let inputId = null;
  let selectMotive = null;
  let startDate = null;
  let endDate = null;
  let date = new Date();

  loadConstains();
  loadInputDate();

  function load(searchFilter) {
    dispatch('load', searchFilter);
  }

  async function loadConstains() {

      params = await paramsService.findByType('modules');
      contains = await containsService.find();

      const paramSelect = params.find(p => p.name == 'Registro General de Entrada y Salida');

      if (!paramSelect) {
      return;
      }

      for (const contain of contains) {
      if (contain.moduleId == paramSelect.id) {
          containsShow.push(contain)
      }
      }

      containsShow.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
      });

      containsShow = containsShow;
  }

  function loadInputDate() {
        let startMonth = '0'; 
        let month = '0';
        if (date.getMonth() < 10 ) {
            month += date.getMonth()+1;
            startMonth += date.getMonth();
        } else {
            month = `${date.getMonth() + 1}`;
            startMonth = `${date.getMonth()}`;
        }
        let year = date.getFullYear()
        let day = date.getDate()

        startDate = year + '-' + startMonth + '-' + day;
        endDate = year + '-' + month + '-' + day;

        let selectedDates = [startDate, endDate];
        loadData(selectedDates,'date');
    }

    function loadData(data, type) {
        if (type == 'id') {
            searchFilterComponent.id = data;
        } else if (type == 'selectMotive') {
          searchFilterComponent.selectMotive = data;
        } else {
          searchFilterComponent.date = data;
        }
        load(JSON.stringify(searchFilterComponent));
    }

    function replaceDate() {
        let popover = document.getElementById('popover');
        popover.hidden = true;
        
        let selectedDates = [startDate, endDate];
        loadData(selectedDates,'date');
    }

    function clearFilter() {
        searchFilterComponent = {
            id : null,
            selectMotive : null,
            date : null
        };
        inputId = null;
        selectMotive = null;
        loadInputDate();
    }
</script>

<div class="container mt-3">
  <div class="row">
      <!-- Input para colocar el número del registro -->
      <div class="col-4 col-sm-4 mb-3">
          <form on:submit|preventDefault={() => loadData(inputId,'id')}>
              <InputGroup>
                  <Input placeholder="Encuentra una identificación" bind:value={inputId} />
                  <button type="submit" class="btn btn-primary"><Icon name="search" /></button>
              </InputGroup>
          </form>
      </div>
      <!-- Select para filtrar por motivo -->
      <div class="col-4 col-sm-4 mb-3">
        <select bind:value={selectMotive} on:change={() => loadData(selectMotive, 'selectCrime')} class='form-select'>
            <option selected value={null}>Seleccionar motivo</option>
            {#each containsShow as contain}
                <option value={contain.id}>{contain.name}</option>
            {/each}
        </select>
      </div>
      <!-- Input para espcificar el rango de fechas para filtrar -->
      <div class="col-4 col-sm-4 mb-3 d-flex">
          
            <button class='btn border border-dark' id='pop'>
                {startDate} - {endDate}
            </button>
            <Popover placement="bottom" target="pop" id='popover'>
                <div id='startDate'>
                    <p>Desde:</p>
                    <Input
                        type='date'
                        bind:value={startDate}
                    />
                </div>
                <div id='endDate'>
                    <p>Hasta</p>
                    <Input
                        type='date'
                        bind:value={endDate}
                    />
                </div>
                <button class='btn btn-primary mt-3' on:click={replaceDate}>Buscar</button>
            </Popover>

          <button class='btn btn-primary ms-1' on:click={clearFilter}><Icon name='eraser' /></button>
      </div>
  </div>
</div>